import moment from 'moment'

export const LIVE_LOCALE = window.Live.settings && window.Live.settings.locale ? window.Live.settings.locale : 'pt_br'

export const timestampToDate = (ts: number): string => {
    if (!ts) return ''

    moment.updateLocale('pt_br', {
        monthsShort: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez']
    })

    return moment(ts).locale(LIVE_LOCALE).format('DD MMM YY - LTS UTC ZZ')
}
